// extracted by mini-css-extract-plugin
export default {"formLabel":"setting-exam-apply-cost_formLabel__6r2-E"};